import ModalContainer from 'components/modal/modal-container'

import ModalActions from 'components/modal/modal-actions'
import { Button } from '@mui/material'

import { closeModal } from 'actions/app'

import { restoreClients } from 'api/client'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { type GridRowId } from '@mui/x-data-grid'

type RestoreClientsProps = {
  selectedClientIds: number[] | string[] | GridRowId[]
  callback: Function
}

export default function RestoreClients(props: RestoreClientsProps) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { selectedClientIds, callback } = props

  const closePopup = () => dispatch(closeModal())

  const restore = () => {
    if (selectedClientIds && selectedClientIds.length > 0) {
      //@ts-expect-error
      dispatch(restoreClients(selectedClientIds, callback))
      dispatch(closeModal())
    } else {
      dispatch(closeModal())
    }
  }
  return (
    <ModalContainer>
      <div>
        {t('restore_items', {
          count: selectedClientIds?.length || 0,
          item: selectedClientIds?.length > 1 ? t('clients') : t('client'),
        })}
      </div>
      <ModalActions>
        <Button variant="contained" color="secondary" onClick={closePopup}>
          {t('cancel')}
        </Button>
        <Button variant="contained" color="primary" onClick={restore}>
          {t('restore')}
        </Button>
      </ModalActions>
    </ModalContainer>
  )
}
